import {
  FETCH_COMMENTS_START,
  FETCH_COMMENTS_SUCCESS,
  FETCH_COMMENTS_FAILURE,
  SAVE_COMMENT_START,
  SAVE_COMMENT_SUCCESS,
  SAVE_COMMENT_FAILURE,
  DELETE_COMMENT_START,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  UPDATE_POST_COMMENTS,
  UPDATE_USER_POST_COMMENTS,
} from "../actions/ActionConstant";

const initialState = {
  comments: {
    // Will store comments per post_id: { post_id: { post_comments: [], nextCursor: null, hasMore: false } }
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
  },
  saveComment: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  delComment: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
};

const CommentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMMENTS_START:
      const postId = action.data.post_id;
      const isFirstPageStart = !action.data.cursor;
      
      return {
        ...state,
        comments: {
          // If first page, reset data. If loading more, keep existing data
          data: isFirstPageStart 
            ? { ...state.comments.data, [postId]: null }
            : state.comments.data,
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading...",
        },
      };
    case FETCH_COMMENTS_SUCCESS:
      const currentPostId = state.comments.inputData.post_id;
      const existingComments = state.comments.data[currentPostId];
      const isFirstPageSuccess = !state.comments.inputData.cursor;
      
      let updatedComments;
      if (isFirstPageSuccess) {
        // First page: replace all data
        updatedComments = action.data;
      } else {
        // Loading more: append to existing comments
        const existingPostComments = existingComments?.post_comments || [];
        const newPostComments = action.data.post_comments || [];
        
        updatedComments = {
          ...action.data,
          post_comments: [...existingPostComments, ...newPostComments]
        };
      }
      
      return {
        ...state,
        comments: {
          data: {
            ...state.comments.data,
            [currentPostId]: updatedComments
          },
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
        },
      };
    case FETCH_COMMENTS_FAILURE:
      return {
        ...state,
        comments: {
          data: state.comments.data,
          loading: false,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
        },
      };
    case SAVE_COMMENT_START:
      return {
        ...state,
        saveComment: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading... Please wait.",
          buttonDisable: true,
        },
      };
    case SAVE_COMMENT_SUCCESS:
      return {
        ...state,
        saveComment: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case UPDATE_POST_COMMENTS:
      // Handle comment updates from other reducers to sync with our new structure
      const updatePostId = action.data.post_id;
      const existingCommentData = state.comments.data[updatePostId];
      
      if (existingCommentData) {
        // Check if this comment already exists to prevent duplicates
        const commentExists = existingCommentData.post_comments.some(
          comment => comment.post_comment_id === action.data.post_comment_id
        );
        
        if (commentExists) {
          return state;
        }
        
        // If we have existing comment data, add the new comment to the top
        const newComment = action.data;
        const updatedComments = {
          ...existingCommentData,
          post_comments: [newComment, ...existingCommentData.post_comments]
        };
        
        return {
          ...state,
          comments: {
            ...state.comments,
            data: {
              ...state.comments.data,
              [updatePostId]: updatedComments
            }
          }
        };
      }
      
      // If no existing comment data, just return state unchanged
      return state;
    case UPDATE_USER_POST_COMMENTS:
      // Handle user post comments updates (same as UPDATE_POST_COMMENTS)
      const userPostId = action.data.post_id;
      const userExistingCommentData = state.comments.data[userPostId];
      
      if (userExistingCommentData) {
        // Check if this comment already exists to prevent duplicates
        const userCommentExists = userExistingCommentData.post_comments.some(
          comment => comment.post_comment_id === action.data.post_comment_id
        );
        
        if (userCommentExists) {
          return state;
        }
        
        // If we have existing comment data, add the new comment to the top
        const newUserComment = action.data;
        const updatedUserComments = {
          ...userExistingCommentData,
          post_comments: [newUserComment, ...userExistingCommentData.post_comments]
        };
        
        return {
          ...state,
          comments: {
            ...state.comments,
            data: {
              ...state.comments.data,
              [userPostId]: updatedUserComments
            }
          }
        };
      }
      
      return state;
    case SAVE_COMMENT_FAILURE:
      return {
        ...state,
        saveComment: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case DELETE_COMMENT_START:
      return {
        ...state,
        delComment: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading...",
          buttonDisable: true,
        },
      };
    case DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        delComment: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case DELETE_COMMENT_FAILURE:
      return {
        ...state,
        delComment: {
          data: {},
          loading: true,
          error: action.data,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };

    default:
      return state;
  }
};

export default CommentsReducer;
